import DialogBox from "../../../core-components/theme/components/DialogBox/DialogBox"
import FilePreviewer from "../../../globalComponents/FilePreviewer"

const FMFileViewer = ({ fileUrl, mimeType, fileName, handleClose }: any) => {
  return (
    <DialogBox
      width="100%"
      maxHeight="75%"
      maxWidth="860px"
      open={true}
      minHeight={"auto"}
      handleClose={handleClose}
      title=""
    >
      <FilePreviewer fileUrl={fileUrl} mimeType={mimeType} fileName={fileName} maxHeight={"100%"} height={"100%"} onClose={handleClose}/>
    </DialogBox>
  )
}

export default FMFileViewer
